module.exports = __webpack_public_path__ + "img/img_lianghua_guoji@3x.57dac903.png";